export default [
    {
        path: "/employee/search",
        name: "EmployeeSearch",
        component: require("@/components/Employee/EmployeeSearchPage").default
    },
    {
        path: "/employee/edit/:id",
        name: "EmployeeEdit",
        component: require("@/components/Employee/EditEmployee").default
    },
    {
        path: '/employee/create',
        name: 'CreateEmployee',
        component: require("@/components/Employee/CreateEmployee").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Employee",
                    path: '/employee/search',
                    query: {
                        employeeName: "",
                        employeeEmail: "",
                        userType: "",
                        division: "",
                        page: 1,
                    }
                },
                {
                    name: "Create"
                }
            ]
        }
    },
];


// WEBPACK FOOTER //
// ./src/router/employee/index.js